module.exports = __webpack_public_path__ + "static/media/new-banner-video.4533296d.mp4";